// extracted by mini-css-extract-plugin
module.exports = {"MobileList":"_7E0SP"};